/* cørt. — the premium standard across cortclub.co.uk (1 Oct 2026, Otis).
   The press, the lift, the reveal, the progress line and the glass header. */
(function(){
  var d=document,r=d.documentElement;
  if(!window.Element||!Element.prototype.animate)return;
  var calm=matchMedia("(prefers-reduced-motion: reduce)").matches,hover=matchMedia("(hover:hover)").matches;
  var EASE="cubic-bezier(.2,.8,.2,1)",SPRING="cubic-bezier(.34,1.45,.64,1)";
  var PRESS=".btn,.button,.cc-btn-primary,.cc-btn-secondary,.cc-qp-btn,.csf-btn,.add-to-cart-button,.featured-cta,.cat-cta,"+
    ".header-actions__action,.cort-signin-action,.email-signup__button,.variant-option__button-label,.cfaq-item summary,"+
    ".cat-card,.pillar-card,.featured-card,.cc-card,.cc-event-card,.cn-card,.product-card,.member-card";
  var CARDS=".cat-card,.pillar-card,.featured-card,.cc-card,.cc-event-card,.cn-card,.product-card";
  var REVEAL=CARDS+",.cfaq-item,main h2";

  /* every press answers: a quick dip, a tiny tap on phones, then it springs back */
  if(!calm){
    d.addEventListener("pointerdown",function(e){
      var b=e.target.closest&&e.target.closest(PRESS);if(!b||b.disabled)return;
      var big=b.matches(CARDS),s=big?.985:.955;
      b.animate([{scale:1},{scale:s}],{duration:90,easing:"ease-out",fill:"forwards",composite:"replace"});
      if(e.pointerType==="touch"&&navigator.vibrate)try{navigator.vibrate(6)}catch(_){}
      function up(){removeEventListener("pointerup",up,true);removeEventListener("pointercancel",up,true);
        var a=b.animate([{scale:s},{scale:1}],{duration:420,easing:SPRING,fill:"forwards"});
        a.onfinish=function(){b.getAnimations().forEach(function(x){if(x.effect&&x.effect.getKeyframes().some(function(k){return"scale"in k}))x.cancel()})}}
      addEventListener("pointerup",up,true);addEventListener("pointercancel",up,true);
    },{passive:true,capture:true});

    /* cards lift towards you on a laptop */
    if(hover){
      d.addEventListener("pointerover",function(e){var c=e.target.closest&&e.target.closest(CARDS);
        if(!c||c.contains(e.relatedTarget))return;
        c.getAnimations().forEach(function(x){if(x.effect&&x.effect.getKeyframes().some(function(k){return"translate"in k}))x.cancel()});
        c.animate([{translate:"0 0"},{translate:"0 -4px"}],{duration:500,easing:SPRING,fill:"forwards"});
        c.addEventListener("pointerleave",function lv(){c.removeEventListener("pointerleave",lv);
          c.animate([{translate:"0 -4px"},{translate:"0 0"}],{duration:450,easing:EASE,fill:"forwards"})});
      },{passive:true});
    }
  }

  function scroller(){var w=d.querySelector(".page-wrapper");
    return w&&/(auto|scroll)/.test(getComputedStyle(w).overflowY)&&w.scrollHeight>w.clientHeight+2?w:d.scrollingElement||r}

  function init(){
    /* the progress line and the glass header follow whichever part of the page scrolls */
    var bar=d.createElement("div");bar.className="cp-progress";bar.setAttribute("aria-hidden","true");d.body.appendChild(bar);
    var tick=false;
    function onScroll(){if(tick)return;tick=true;requestAnimationFrame(function(){tick=false;
      var s=scroller(),y=s.scrollTop,mx=s.scrollHeight-s.clientHeight;
      bar.style.transform="scaleX("+(mx>40?Math.min(1,y/mx):0)+")";
      r.classList.toggle("cp-scrolled",y>8)})}
    d.addEventListener("scroll",onScroll,{passive:true,capture:true});addEventListener("resize",onScroll);onScroll();
    if(calm)return;

    /* things below the first screen rise in as you reach them; groups cascade */
    if(!("IntersectionObserver"in window))return;
    var fold=innerHeight,seen=new Set();
    function show(el,i){if(!el.classList.contains("cp-rv"))return;io.unobserve(el);el.classList.remove("cp-rv");
      el.animate([{opacity:0,translate:"0 22px"},{opacity:1,translate:"0 0"}],
        {duration:800,delay:Math.min(i,8)*70,easing:EASE,fill:"backwards"})}
    var io=new IntersectionObserver(function(es){
      es.filter(function(e){return e.isIntersecting}).forEach(function(e,i){show(e.target,i)});
      catchUp();
    },{rootMargin:"0px 0px -6% 0px"});
    /* a fast fling must never leave something hidden above you */
    function catchUp(){[].forEach.call(d.querySelectorAll(".cp-rv"),function(el){
      if(el.getBoundingClientRect().top<innerHeight)show(el,0)})}
    var cu=0;d.addEventListener("scroll",function(){if(cu)return;cu=setTimeout(function(){cu=0;catchUp()},180)},{passive:true,capture:true});
    function tag(root){[].forEach.call((root||d).querySelectorAll(REVEAL),function(el){
      if(seen.has(el))return;seen.add(el);
      if(el.parentElement&&el.parentElement.closest(CARDS))return;
      if(el.closest(".reveal,[class*=\"reveal-\"],.in-view"))return;
      if(!el.getClientRects().length)return;
      if(el.getBoundingClientRect().top<fold*.92)return;
      el.classList.add("cp-rv");io.observe(el)})}
    tag();
    /* a safety net: nothing stays hidden if the observer never fires */
    setTimeout(catchUp,2500);
    flow();
  }

  /* ---- the flow (1 Oct, Brent: "as we go down the page… make it flow… feel more together").
     The page moves WITH your finger instead of in separate jumps: each section rises and
     brightens as it comes up, the one you are leaving settles back, pictures settle into
     their frames, things inside a section arrive one after another, and on a laptop a
     chapter rail on the right shows where you are and takes you anywhere in one press. ---- */
  function flow(){
    var vh=innerHeight;
    function fixedInside(el){var all=el.getElementsByTagName("*");
      for(var i=0;i<all.length;i++){var p=getComputedStyle(all[i]).position;if(p==="fixed"||p==="sticky")return true}return false}
    var home=d.querySelector(".cortv2");
    var secs=[].slice.call(d.querySelectorAll(".cortv2 > section:not(.hero), main .shopify-section"))
      .filter(function(s){return !s.querySelector(".cortv2")&&!s.closest("header,footer,.cortv2 > section.hero")&&
        s.offsetHeight>120&&!s.matches("[id*=main-product],[id*=__main]")&&!fixedInside(s)});

    /* things inside one section arrive one after another, not all at once */
    if(home)[].forEach.call(home.children,function(sec){var n=0;
      [].forEach.call(sec.querySelectorAll(".reveal"),function(el){
        if(!/--d/.test(el.getAttribute("style")||""))el.style.setProperty("--d",(Math.min(n,6)*.07).toFixed(2)+"s");n++})});

    /* pictures settle into their frames as you reach them */
    var pics=[].slice.call(d.querySelectorAll("main img, main video")).filter(function(m){
      if(m.closest(".product-card,product-card,.product-grid,.cart-drawer,header,footer,[id*=main-product]"))return false;
      var f=m.parentElement;if(!f||m.offsetHeight<180)return false;
      var o=getComputedStyle(f).overflow;return /hidden|clip/.test(o)});

    function sc(){return scroller()}
    function ease(t){return 1-Math.pow(1-t,3)}
    var busy=false;
    function frame(){busy=false;var s=sc(),y=s.scrollTop,mx=s.scrollHeight-s.clientHeight;vh=innerHeight;
      secs.forEach(function(el){var b0=el.getBoundingClientRect(),ty=el.__ty||0;
        var b={top:b0.top-ty,bottom:b0.bottom-ty};
        var end=Math.max(vh*.62,b.top-(mx-y)+1),pin=vh-end>4?Math.min(1,Math.max(0,(vh-b.top)/(vh-end))):1;
        var q=b.bottom<vh*.3?Math.min(1,(vh*.3-b.bottom)/(vh*.3)):0;
        if(pin>=1&&q<=0){if(el.__cp){el.style.translate=el.style.scale=el.style.opacity="";el.__cp=0;el.__ty=0}return}
        var e=ease(pin);el.__cp=1;
        el.__ty=(1-e)*56;el.style.translate="0 "+el.__ty.toFixed(1)+"px";
        el.style.scale=(1-(1-e)*.025-q*.03).toFixed(4);
        el.style.opacity=(Math.min(.35+.65*e,1-q*.55)).toFixed(3)});
      pics.forEach(function(m){var b=m.getBoundingClientRect();if(b.bottom<-40||b.top>vh+40)return;
        var t=Math.min(1,Math.max(0,(vh-b.top)/(vh*.9+b.height*.2)));m.style.scale=(1.1-.1*ease(t)).toFixed(4)});
      if(rail)railFrame()}
    function onS(){if(!busy){busy=true;requestAnimationFrame(frame)}}

    /* the chapter rail (laptop, home page) */
    var rail=null,marks=[];
    if(home&&hover&&innerWidth>=1100){
      var chs=[].slice.call(home.querySelectorAll(":scope > section")).filter(function(s){return s.querySelector("h2")});
      rail=d.createElement("nav");rail.className="cp-rail";rail.setAttribute("aria-label","Sections");
      chs.forEach(function(s,i){var h=s.querySelector("h2"),eb=s.querySelector("[class*=eyebrow]");
        var name=(eb&&eb.textContent.replace(/^\s*\d+\s*[—-]\s*/,"").trim())||h.textContent.trim();
        var a=d.createElement("button");a.type="button";a.className="cp-rail__dot";
        a.innerHTML="<span class=\"cp-rail__label\"></span>";a.firstChild.textContent=name.length>28?name.slice(0,26)+"…":name;
        a.setAttribute("aria-label",name);
        a.addEventListener("click",function(){var sc0=sc(),top=s.getBoundingClientRect().top-(s.__ty||0)-90;
          (sc0===d.scrollingElement||sc0===r?window:sc0).scrollBy({top:top,behavior:"smooth"})});
        rail.appendChild(a);marks.push([s,a])});
      d.body.appendChild(rail)}
    function railFrame(){var cur=-1;marks.forEach(function(m,i){if(m[0].getBoundingClientRect().top<innerHeight*.45)cur=i});
      rail.classList.toggle("cp-rail--on",cur>=0||sc().scrollTop>innerHeight*.5);
      marks.forEach(function(m,i){m[1].classList.toggle("is-on",i===Math.max(cur,0))})}

    d.addEventListener("scroll",onS,{passive:true,capture:true});addEventListener("resize",onS);frame();
  }
  d.readyState!=="loading"?init():d.addEventListener("DOMContentLoaded",init);
})();
